"use client";

function ExperiencePage(props: { yScroll?: number }) {
  return (
    <div className="full-screen py-24 px-2 md:px-[5%] flex items-center justify-center">
      <div className="container">
        <div className="block md:flex md:justify-center gap-12 mb-4">
          <h1 className="text-2xl text-black font-medium md:w-1/2 lg:w-5/12 xl:w-1/3 h-auto ">
            Project Experience
          </h1>
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit" />
        </div>
        <div className="block md:flex md:justify-center gap-12">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Commercial Developments</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>• Office buildings (up to 20 storeys)</div>
              <div>• Retail complexes</div>
              <div>• Restaurant and café fit-outs</div>
              <div>• Boutique hotels</div>
            </div>
          </div>
          <img
            src="/images/experience/1.jpg"
            alt="1"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Residential Projects</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>• Private housing developments</div>
              <div>• Apartment renovations</div>
              <div>• Luxury villa constructions</div>
              <div>• Residential estate upgrades</div>
            </div>
          </div>
          <img
            src="/images/experience/2.jpg"
            alt="2"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Institutional Works</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>• School extensions</div>
              <div>• Community center refurbishments</div>
              <div>• Small-scale medical clinics</div>
              <div>• Religious institution renovations</div>
            </div>
          </div>
          <img
            src="/images/experience/3.jpg"
            alt="3"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Our Value-Added Approach</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>Unlike larger firms, we bring:</div>
              <div>✓ Hands-on director involvement in every project</div>
              <div>
                ✓ Tailored solutions for projects with budgets of HK$5M-200M
              </div>
              <div>
                ✓ Practical cost advice from professionals who regularly visit
                sites
              </div>
              <div>
                ✓ Flexible engagement models for different project phases
              </div>
            </div>
          </div>
          <img
            src="/images/experience/4.jpg"
            alt="3"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
      </div>
    </div>
  );
}

export default ExperiencePage;
